/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_ContrastInputs */

const en_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color contrasts per WCAG 2.2 AA`)
};

const de_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbkontraste gemäß WCAG 2.2 AA`)
};

const fr_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrastes de couleurs selon WCAG 2.2 AA`)
};

const es_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrastes de color segun WCAG 2.2 AA`)
};

const it_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrasti cromatici secondo WCAG 2.2 AA`)
};

const nl_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleurcontrasten volgens WCAG 2.2 AA`)
};

const pl_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrasty kolorow zgodnie z WCAG 2.2 AA`)
};

const fi_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varikontrastitasot WCAG 2.2 AA:n mukaisesti`)
};

const da_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farvekontrastkrav iht. WCAG 2.2 AA`)
};

const sv_a11y_statement_accessible_contrast = /** @type {(inputs: A11y_Statement_Accessible_ContrastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fargkontrast enligt WCAG 2.2 AA`)
};

/**
* | output |
* | --- |
* | "Color contrasts per WCAG 2.2 AA" |
*
* @param {A11y_Statement_Accessible_ContrastInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_contrast = /** @type {((inputs?: A11y_Statement_Accessible_ContrastInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_ContrastInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_contrast(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_contrast(inputs)
	if (locale === "es") return es_a11y_statement_accessible_contrast(inputs)
	if (locale === "it") return it_a11y_statement_accessible_contrast(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_contrast(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_contrast(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_contrast(inputs)
	if (locale === "da") return da_a11y_statement_accessible_contrast(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_contrast(inputs)
	return en_a11y_statement_accessible_contrast(inputs)
});